<?php

\Core\View::$template = function() {

    $greeting = '<h1>Hi, <strong>there</strong></h1>';
    $back_button = '<span id="go-home-page" class="btn btn-warning">Back</span>';
    $user_logged = \ISOPHP\core::$registry->getValue('user_logged') ;
    \ISOPHP\js_core::$console->log('user logged: ', $user_logged);
    if (isset($user_logged['user']) && $user_logged['user']['full_name'] !== '') {
        \ISOPHP\js_core::$console->log('home summary user full name') ;
        $moniker = $user_logged['user']['full_name'] ;
        $greeting = '<span>Hello, <strong>'.$moniker.'</strong></span>';
    }
    $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'] ;

    $html = '
        <link rel="stylesheet" type="text/css" href="' . CSS_ASSET_PREFIX . 'app/UserAccount/Assets/css/default.css">
        <header class="col-sm-12 navbar inside-navbar">
          <div class="col-sm-2 col-12 xs-center">            
            <img class="nav_logo" src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/logg.png" height="80" />
          </div>
          <div class="col-sm-4 col-12 xs-center">
            <span>'. $greeting .' </span> 
            <p>Home @ Video Interviews</p>
          </div>
          <div class="col-sm-6 col-12 xs-center">
            <div id="user-menu-button" class="menu-button user-menu-button menu-btn-top">
              <!--<div id="user_menu_entries" class="menu_entries user_menu_entries">
              <div class="menu_entry">
                <span id="user_menu_link_job_list">Job List</span>
              </div>
            </div>-->
          </div>
          <div id="user-menu-button" class="menu-button user-menu-button"></div>
          <div id="settings-menu-button" class="menu-button settings-menu-button"></div>
        </div>
      </header> ';

    $html = $html . '
        <section class="latest">
          <div class="container-fluid"> 
            <div class="row">
              <div class="col-sm-12 text-center">
                <div class="latest_wrap">
                  <p><label>Latest Login: </label><span id="latest-login-date"> </span><span  id="latest-login-time"> </span></p>
                </div> 
                
              </div>  
            </div>
          </div>
        </section>  ';

    $html = $html . ' <div class="col-sm-12" id="user_account">';
    $html = $html . '  No data found.  ' ;
    $html = $html . ' </div>  ' ;

    $html = $html . '    <div class="col-sm-12 back_btn_wrap">' ;
    $html = $html . $back_button ;
    $html = $html . '    </div>' ;

    $html = $html . '</form>' ;

    $html = $html .'
        <section class="footer-bottom">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-3 col-12 col-xs-12 col-lg-3 xs-center">
            © 2023 Video Interviews
          </div>' ;

    if (CURRENT_TARGET !== 'mobile') {
        $html = $html .'
          <div class="col-md-9 col-9 col-xs-12 col-lg-9">
            <ul class="footer-links">
              <li>
                <a href="#">Hire Quality</a>
              </li>
              <li>
                <a class="go-jobslist" href="/jobslist">Jobs</a>
              </li>
              <li>
                <a href="#">Careers</a>
              </li>
              <li>
                <a href="#">Privacy</a>
              </li>
              <li>
                <a href="#">Terms</a>
              </li>
              <li>
                <a href="#">Contact</a>
              </li>
              <li>
                <a href="#">Twitter</a>
              </li>
            </ul>
          </div> ';
    }

    $html = $html .'
        </div>
      </div>
    </section>
    ';

    return $html ;

} ;


// WEBPACK FOOTER //
// app/UserAccount/View/UserAccount.php